import React from "react";
import { Link } from "react-router-dom";
import { dateParts, isEventPast } from "../../utils/date";

const EventCard = ({ ev, slug }) => {
  const { d, m } = dateParts(ev.date);
  const cover = ev.coverUrl || ev.image || ev.coverImageUrl || "/images/fotos/placeholder.svg";

  const effectiveSlug = slug || ev.clientId?.slug;
  const href = effectiveSlug ? `/${effectiveSlug}/events/${ev._id || ev.id}` : '#';

  const isPast = isEventPast(ev.date);
  const year = new Date(ev.date).getFullYear();
  const time = ev.startTime || "22:30";

  return (
    <Link
      to={href}
      className={`group block bg-[#0D0D0D] border border-white/5 rounded-2xl overflow-hidden transition-all duration-300 hover:border-white/20 ${isPast ? 'opacity-60 grayscale-[0.5]' : ''}`}
    >
      <div className="relative aspect-square overflow-hidden">
        <img
          src={cover}
          alt={ev.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {isPast && (
          <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
            <span className="text-[10px] font-black uppercase tracking-[3px] text-white py-2 px-4 border border-white/20 rounded-lg backdrop-blur-sm">Finalizado</span>
          </div>
        )}
      </div>

      <div className="p-5">
        <p className="text-[11px] font-medium text-white/30 truncate mb-1.5">
          {ev.clientId?.nombre || "Cargando..."}
        </p>
        <h3 className="text-lg font-bold text-white leading-tight mb-6 line-clamp-1">
          {ev.title}
        </h3>

        <div className="grid grid-cols-2 gap-4 pt-4 border-t border-white/5 bg-white/[0.02] -mx-5 px-5 pb-5 rounded-b-2xl">
          <div>
            <p className="text-[10px] font-medium text-white/30 uppercase tracking-wider mb-1">Precio</p>
            <p className="text-sm font-bold text-white">
              {ev.price > 0 ? `Desde $${ev.price.toLocaleString('es-AR')}` : 'GRATIS'}
            </p>
          </div>
          <div className="text-left">
            <p className="text-[10px] font-medium text-white/30 uppercase tracking-wider mb-1">Fecha</p>
            <p className="text-xs font-bold text-white">
              {time} - {d}/{m}/{year}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default EventCard;
